export enum FormPageType {
  First = 1,
  Second = 2,
}
